export const siteInfo = {
  name: '吃瓜视频',
  tagline: '全网热点 · 每日更新',
  slogan: '即点即看，海量吃瓜视频每日更新',
  intro: '吃瓜视频是国内领先的热点娱乐视频在线播放平台，专注于为网友提供最新、最全、最高清的吃瓜视频内容。平台每日从全网筛选热门娱乐动态、明星八卦、社会热点事件，经过专业编辑整理后以视频形式呈现，让用户无需切换多个平台，即可一站式掌握当天最火的"瓜"。无论你是想了解娱乐圈最新动向，还是关注网络热议的社会话题，吃瓜视频都能满足你的需求——高清流畅播放、无广告打扰、即点即看无需等待，随时随地畅享吃瓜乐趣。',
  stats: [
    { label: '每日更新视频', value: '500+' },
    { label: '覆盖话题领域', value: '30+' },
    { label: '全高清画质', value: '1080P' },
  ],
};

export const rankingItems = [
  { rank: 1, title: '某顶流艺人深夜发文引热议，粉丝集体炸锅', hot: '286万热度', tag: '爆', tagColor: 'bg-accent-500' },
  { rank: 2, title: '热门综艺录制现场意外曝光，嘉宾真实关系揭秘', hot: '243万热度', tag: '热', tagColor: 'bg-primary-500' },
  { rank: 3, title: '知名导演新片选角内幕，多位一线明星参与角逐', hot: '198万热度', tag: '热', tagColor: 'bg-primary-500' },
  { rank: 4, title: '社交媒体平台突发故障，网友涌入其他平台吐槽', hot: '165万热度', tag: '新', tagColor: 'bg-secondary-500' },
  { rank: 5, title: '热门网剧第二季官宣阵容，原班人马悉数回归', hot: '142万热度', tag: '热', tagColor: 'bg-primary-500' },
  { rank: 6, title: '年度音乐盛典获奖名单提前泄露？官方回应来了', hot: '128万热度', tag: '新', tagColor: 'bg-secondary-500' },
];

export const updateItems = [
  { time: '15分钟前', content: '某知名女星机场街拍造型引发网友大规模讨论，评论区两极分化严重' },
  { time: '42分钟前', content: '热门短视频平台推出新功能，创作者收益分成模式迎来重大调整' },
  { time: '1小时前', content: '年度爆款电影续集确认开拍，导演发长文回应选角争议' },
  { time: '2小时前', content: '网传某品牌代言人即将更换，现任代言人工作室保持沉默' },
  { time: '3小时前', content: '综艺节目录制期间突发状况，制作组紧急发布安全声明' },
  { time: '5小时前', content: '知名音乐人发布新专辑预告，曲风转型引发乐评人热议' },
  { time: '7小时前', content: '热门游戏主播疑似合约到期，多个平台展开争夺战' },
];

export const featureItems = [
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '专业编辑团队 7×24 小时全网监控，热点事件发生后最快 15 分钟内上架相关视频内容，确保你永远不会错过任何一个"大瓜"。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清流畅',
    desc: '全站视频支持 1080P 高清画质播放，智能 CDN 加速确保流畅不卡顿，无论是手机流量还是 WiFi 环境下都能获得最佳观看体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    desc: '严格的内容审核机制与纯净的播放环境，无恶意弹窗、无强制下载、无诱导分享，给你一个安心舒适的吃瓜空间。',
  },
];

export const faqItems = [
  {
    q: '吃瓜视频的内容来源是什么？',
    a: '我们的内容团队每日从全网主流社交平台、新闻媒体和视频网站筛选最新热点事件，经过核实和编辑处理后制作成视频内容。所有内容均基于公开信息整理，确保信息的真实性和时效性。',
  },
  {
    q: '是否需要注册才能观看视频？',
    a: '不需要！吃瓜视频的所有内容均免费开放，无需注册、无需登录即可直接观看。我们坚持"即点即看"的理念，让每一位用户都能零门槛享受吃瓜乐趣。',
  },
  {
    q: '手机端观看体验怎么样？',
    a: '吃瓜视频采用响应式设计，完美适配手机、平板和电脑等多种设备。手机端自动优化播放界面，支持手势控制音量、亮度和进度，横竖屏自由切换，给你移动端最佳的观看体验。',
  },
  {
    q: '如何向我们投稿或提供线索？',
    a: '欢迎通过页面底部的联系方式向我们投稿或提供热点线索。我们的编辑团队会在收到信息后尽快核实处理，优质线索一经采用将注明来源并给予感谢。',
  },
];

export const cardItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20entertainment%20news%20studio%20set%20with%20warm%20lighting%2C%20microphone%20and%20headlines%20on%20digital%20screens%2C%20professional%20broadcast%20atmosphere%2C%20editorial%20photography%20style&width=800&height=500&seq=card-01&orientation=landscape',
    tag: '娱乐八卦',
    title: '娱乐圈最新风向：本季度最值得关注的十大事件盘点',
    summary: '从顶流动态到新人出道，一文速览近期娱乐圈不可错过的重磅消息。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20social%20media%20monitoring%20command%20center%20with%20multiple%20screens%20showing%20trending%20topics%2C%20warm%20golden%20ambient%20lighting%2C%20tech%20aesthetic&width=800&height=500&seq=card-02&orientation=landscape',
    tag: '社会热点',
    title: '本周网络热议话题复盘：哪些事件引发了全民讨论',
    summary: '从社会事件到民生话题，梳理本周最具影响力的话题讨论。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20movie%20director%20scene%20with%20film%20camera%20equipment%20and%20warm%20spotlight%2C%20cinematic%20atmosphere%20with%20creative%20composition%2C%20artistic%20photography&width=800&height=500&seq=card-03&orientation=landscape',
    tag: '影视综',
    title: '下半年待播热门剧集前瞻：这些作品最受期待',
    summary: '多部大制作蓄势待发，看看哪些剧集可能成为年度爆款。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20music%20studio%20scene%20with%20recording%20equipment%2C%20warm%20moody%20lighting%2C%20instruments%20in%20background%2C%20creative%20editorial%20style&width=800&height=500&seq=card-04&orientation=landscape',
    tag: '音乐动态',
    title: '华语乐坛近期新歌盘点：这些作品值得加入歌单',
    summary: '多位实力歌手发布新作，不同风格的精彩碰撞不容错过。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20live%20streaming%20room%20setup%20with%20ring%20light%2C%20gaming%20gear%2C%20and%20warm%20neon%20accents%2C%20modern%20content%20creator%20aesthetic%2C%20editorial%20photography&width=800&height=500&seq=card-05&orientation=landscape',
    tag: '网红达人',
    title: '短视频平台近期走红的新面孔：谁是下一个顶流',
    summary: '盘点近期涨粉最快的创作者，分析他们的走红密码。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20Korean%20drama%20viewing%20setup%20with%20warm%20ambient%20lighting%2C%20comfortable%20sofa%2C%20large%20TV%20screen%2C%20stylized%20editorial%20photography&width=800&height=500&seq=card-06&orientation=landscape',
    tag: '综艺节目',
    title: '热门综艺新一季路透不断：录制花絮引发观众期待',
    summary: '多档王牌综艺陆续开录，从嘉宾阵容到环节设置全面前瞻。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20news%20aggregation%20visual%20with%20floating%20headlines%2C%20warm%20golden%20light%2C%20digital%20interface%20elements%2C%20clean%20aesthetic%20editorial%20design&width=800&height=500&seq=card-07&orientation=landscape',
    tag: '深度吃瓜',
    title: '本月最全吃瓜指南：从娱乐圈到互联网的精彩故事',
    summary: '精选本月最值得关注的各类话题，一篇看完所有热点。',
  },
];

export const appInfo = {
  title: '随时随地，畅享吃瓜',
  desc: '吃瓜视频全面适配移动端浏览器，无需下载安装即可获得原生 App 般的流畅体验。支持手势控制、画中画播放、后台音频播放，让你在通勤、午休、睡前随时追最新热点。收藏本站到手机桌面，一键直达吃瓜世界。',
  features: ['免安装即用', '手势操控播放', '画中画模式', '收藏到桌面'],
  image: 'https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20a%20modern%20Chinese%20entertainment%20video%20app%20interface%20with%20warm%20coral%20accent%20colors%2C%20clean%20card%20layout%2C%20stylized%20editorial%20product%20photography%20on%20soft%20warm%20background&width=600&height=900&seq=app-showcase&orientation=portrait',
};

export const aboutInfo = {
  title: '关于吃瓜视频',
  paragraphs: [
    '吃瓜视频创立于对网络热点文化的深度洞察——在信息爆炸的时代，每一个"瓜"都可能在几分钟内被新的热点淹没。我们致力于打造一个专业的热点娱乐视频聚合平台，让每一位用户都能以最便捷的方式跟进最新动态，不错过任何精彩瞬间。',
    '我们的编辑团队由资深媒体人和网络文化研究者组成，日均处理上千条热点线索，通过严格的信息核实与内容筛选流程，确保每一条视频都具备传播价值。从娱乐圈到互联网，从社会事件到文化现象，吃瓜视频以独特的视角和专业的制作，为超过百万用户提供高质量的吃瓜体验。',
    '我们相信，吃瓜不仅是消遣，更是当代人理解社会、参与公共讨论的一种方式。未来，吃瓜视频将继续优化内容质量和用户体验，打造更完善的视频生态，让"来吃瓜视频看最新热点"成为每个人的日常习惯。',
  ],
  image: 'https://readdy.ai/api/search-image?query=A%20modern%20creative%20content%20team%20workspace%20with%20warm%20lighting%2C%20multiple%20monitors%20displaying%20video%20editing%20timeline%2C%20collaborative%20atmosphere%2C%20stylized%20editorial%20photography%20with%20clean%20composition&width=1000&height=667&seq=about-team&orientation=landscape',
};

export const indexItems = [
  { icon: 'ri-fire-line', title: '今日热搜', desc: '实时更新的热门话题榜单', color: 'text-accent-500' },
  { icon: 'ri-live-line', title: '直播追踪', desc: '重大事件全程跟进报道', color: 'text-primary-500' },
  { icon: 'ri-movie-2-line', title: '影视专区', desc: '热门影视剧相关话题合集', color: 'text-secondary-500' },
  { icon: 'ri-music-2-line', title: '音乐动态', desc: '华语及国际乐坛最新资讯', color: 'text-accent-500' },
  { icon: 'ri-user-star-line', title: '明星八卦', desc: '娱乐圈明星最新动态', color: 'text-primary-500' },
  { icon: 'ri-global-line', title: '社会热点', desc: '全民关注的社会事件解读', color: 'text-secondary-500' },
  { icon: 'ri-gamepad-line', title: '游戏电竞', desc: '游戏圈与电竞行业资讯', color: 'text-accent-500' },
  { icon: 'ri-tiktok-line', title: '短视频热榜', desc: '各大平台热门视频精选', color: 'text-primary-500' },
  { icon: 'ri-lightbulb-line', title: '观点评论', desc: '深度分析与独特视角', color: 'text-secondary-500' },
];

export const topicItems = [
  { name: '顶流新剧路透', heat: '356万讨论' },
  { name: '综艺录制路透', heat: '289万讨论' },
  { name: '明星机场穿搭', heat: '234万讨论' },
  { name: '新歌首发预告', heat: '198万讨论' },
  { name: '品牌代言官宣', heat: '176万讨论' },
  { name: '电影票房排行', heat: '154万讨论' },
  { name: '直播带货翻车', heat: '132万讨论' },
  { name: '短视频新梗', heat: '118万讨论' },
  { name: '网红恋情曝光', heat: '96万讨论' },
  { name: '综艺名场面', heat: '87万讨论' },
];

export const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20wide%20banner%20showing%20Chinese%20entertainment%20industry%20scene%2C%20red%20carpet%20with%20spotlights%2C%20warm%20dramatic%20lighting%2C%20cinematic%20atmosphere%2C%20editorial%20photography%20with%20clean%20composition&width=800&height=420&seq=carousel-01&orientation=landscape',
    tag: '年度盘点',
    title: '2026上半年娱乐圈大事记',
    desc: '从开年大瓜到年中爆款，带你回顾这半年来最精彩的热点事件。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20film%20set%20with%20camera%20equipment%20and%20crew%20working%2C%20warm%20golden%20hour%20lighting%2C%20cinematic%20depth%20of%20field%2C%20stylized%20editorial%20photography&width=800&height=420&seq=carousel-02&orientation=landscape',
    tag: '独家策划',
    title: '当红导演创作谈：从剧本到成片的故事',
    desc: '多位一线导演独家分享创作幕后，揭秘大热作品的诞生过程。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20concert%20stage%20with%20colorful%20lighting%20and%20large%20crowd%2C%20energetic%20atmosphere%2C%20warm%20and%20vibrant%20tones%2C%20editorial%20photography&width=800&height=420&seq=carousel-03&orientation=landscape',
    tag: '音乐盛典',
    title: '年度音乐颁奖礼全纪录',
    desc: '各大奖项花落谁家？红毯造型、获奖感言、后台花絮一网打尽。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20streaming%20platform%20visual%20with%20floating%20video%20thumbnails%2C%20warm%20ambient%20light%2C%20digital%20interface%20elements%2C%20clean%20editorial%20design%20aesthetic&width=800&height=420&seq=carousel-04&orientation=landscape',
    tag: '追剧指南',
    title: '暑期档热门剧集终极追剧清单',
    desc: '多部大热剧集扎堆上线，这份追剧时间表请务必收藏好。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20social%20media%20trending%20visualization%20with%20glowing%20data%20points%2C%20warm%20coral%20and%20gold%20tones%2C%20modern%20tech%20aesthetic%2C%20editorial%20design&width=800&height=420&seq=carousel-05&orientation=landscape',
    tag: '数据揭秘',
    title: '上半年社交平台热搜词大起底',
    desc: '用数据说话，看看哪些关键词承包了上半年的网络热搜榜。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20entertainment%20studio%20with%20microphones%2C%20headphones%2C%20and%20recording%20equipment%2C%20warm%20intimate%20lighting%2C%20podcast%20production%20aesthetic%2C%20editorial%20photography&width=800&height=420&seq=carousel-06&orientation=landscape',
    tag: '深度访谈',
    title: '娱乐圈幕后人物系列专访',
    desc: '对话经纪人、制片人、宣发团队，从不同视角读懂娱乐产业。',
  },
];

export const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20video%20player%20interface%20with%20play%20button%2C%20warm%20lighting%2C%20modern%20minimal%20design%2C%20entertainment%20content%20thumbnail%2C%20stylized%20editorial%20aesthetic&width=640&height=360&seq=media-01&orientation=landscape',
    title: '年度热搜人物大盘点：谁霸占了上半年的头条',
    duration: '15:28',
    views: '128万次观看',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20video%20thumbnail%20with%20entertainment%20news%20theme%2C%20warm%20lighting%2C%20professional%20broadcast%20style%2C%20modern%20clean%20design%2C%20editorial%20photography&width=640&height=360&seq=media-02&orientation=landscape',
    title: '热门综艺名场面合集：那些让人笑到停不下来的瞬间',
    duration: '12:06',
    views: '96万次观看',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20video%20content%20thumbnail%20with%20social%20media%20trending%20theme%2C%20warm%20ambient%20lighting%2C%20clean%20editorial%20style%2C%20stylized%20composition&width=640&height=360&seq=media-03&orientation=landscape',
    title: '本周网络热议事件汇总：一口气看完所有热点',
    duration: '18:42',
    views: '85万次观看',
  },
];

export const contactInfo = {
  title: '投稿与合作',
  desc: '如果你有独家线索、优质内容或商业合作意向，欢迎通过以下方式联系我们。吃瓜视频期待与更多创作者和品牌建立合作关系，共同打造更丰富的内容生态。',
  email: 'contact@chiguavideo.com',
  wechat: 'chigua_official',
  weibo: '@吃瓜视频官方',
};

export const commentItems = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20headshot%20portrait%20of%20a%20Chinese%20young%20professional%2C%20warm%20lighting%2C%20clean%20background%2C%20friendly%20expression&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜群众小陈',
    time: '2小时前',
    content: '这个平台真的太赞了！更新速度比我自己刷微博还快，而且视频画质清晰，没有乱七八糟的广告，已经成为我每天的必刷网站了。',
    likes: 326,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20headshot%20portrait%20of%20a%20Chinese%20young%20woman%2C%20warm%20lighting%2C%20clean%20background%2C%20friendly%20expression&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '娱乐达人莉莉',
    time: '5小时前',
    content: '吃瓜视频的内容编辑很有水平，不光是搬运，还有自己的分析和梳理，看完一个视频就能把一个事件的来龙去脉搞清楚，这点比其他平台强太多了。',
    likes: 218,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20headshot%20portrait%20of%20a%20Chinese%20young%20man%2C%20warm%20lighting%2C%20clean%20background%2C%20friendly%20expression&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '追瓜第一线',
    time: '8小时前',
    content: '界面设计很清爽，手机端体验特别好，通勤路上刷一刷就到公司了。希望持续更新更多优质内容，已经推荐给身边的朋友们了！',
    likes: 175,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20headshot%20portrait%20of%20a%20Chinese%20young%20woman%20smiling%2C%20warm%20lighting%2C%20clean%20background%2C%20friendly%20expression&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '八卦研究员',
    time: '12小时前',
    content: '作为一个资深吃瓜人，这里的信息整合做得确实专业。热点覆盖全面，从娱乐到社会话题都有涉及，而且更新频率让人满意。',
    likes: 142,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20headshot%20portrait%20of%20a%20Chinese%20young%20man%20with%20glasses%2C%20warm%20lighting%2C%20clean%20background%2C%20friendly%20expression&width=80&height=80&seq=avatar-05&orientation=squarish',
    name: '新媒体人阿杰',
    time: '1天前',
    content: '从行业从业者的角度看，吃瓜视频的内容策略和运营节奏把握得很好。视频制作质量稳定，选题角度独特，在这个赛道里算是佼佼者了。',
    likes: 98,
  },
];